module.exports = __webpack_public_path__ + "static/1-f1aa4858c0ad6f0a3c3ad12218bf12d0.jpg";